import { localityTransformNames } from './formatters';

export const getLocality = (address) =>
  localityTransformNames(
    address?.address_components?.find((i) =>
      i?.types?.some((type) => type === 'locality')
    )?.long_name
  );
